module.exports = __webpack_public_path__ + "components/team-member/static/linkedin-4dd0f9efff45104c4404eb8aa170ea6c.svg";